import React, { useEffect ,useState} from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createPhotographs, getPhotograph, resetState, updatePhotograph } from "../features/PhotographsSlice";
import { toast } from "react-toastify";
let schema = yup.object().shape({
});

const AddPhotographs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.Photograph);
  const { isSuccess, isError, isLoading, createdPhotograph, PhotographName, PhotographshortName, Photographemail, PhotographPassword, Photographtype, updatedPhotograph } = NewsState;
  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState("");
  

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getPhotograph(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsId]);

  useEffect(() => {
    dispatch(resetState());
   
  }, []);

  useEffect(() => {
    if (isSuccess && createdPhotograph) {
      toast.success("Photograph Added Successfully!");
      dispatch(resetState());
    }
    if (isSuccess && updatedPhotograph) {
      toast.success("Photograph Updated Successfully!");
      navigate("/ppp/Photographs-List");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (!image ) {
        setImageError("Please select an image.");
        return;
      } else {
        setImageError("");
      }
      
      const formData = new FormData();
      
      formData.append("image", image);
      
      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: formData };
        dispatch(updatePhotograph(data));
        dispatch(resetState());
      } else {
        dispatch(createPhotographs(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });



  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Photograph</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <label htmlFor="image" className="form-label">
              Select Logo
            </label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                setImage(e.target.files[0]);
                setImageError(""); 
              }}
              className="form-control"
            />
            <div className="error">{imageError}</div>
          </div>

          

          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Photograph
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddPhotographs;